import {ClassProvider, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {FullComponent} from "./layouts/full/full.component";
import {WatchdogMaterialModule} from "./material-module";
import {AppHeaderComponent} from "./layouts/full/header/header.component";
import {AppSidebarComponent} from "./layouts/full/sidebar/sidebar.component";
import {RouterModule} from "@angular/router";
import {AppRoutes} from "./app.routes";
import {SharedModule} from "./shared/shared.module";
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {LoggingInterceptor} from "./services/http/LoggingInterceptor";
// import {AuthInterceptor} from "./services/http/auth-interceptor";
import {NgOptimizedImage} from "@angular/common";
import {AuthModule, LogLevel} from "angular-auth-oidc-client";
import {AuthInterceptor} from "./services/http/auth-interceptor";
import {environment} from "../environments/environment";

const LOGGING_INTERCEPTOR_PROVIDER: ClassProvider = {
  provide: HTTP_INTERCEPTORS ,
  useClass: LoggingInterceptor,
  multi: true
};

const AUTH_INTERCEPTOR_PROVIDER: ClassProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: AuthInterceptor,
  multi: true
};


@NgModule({
  declarations: [
    AppComponent,
    FullComponent,
    AppHeaderComponent,
    AppSidebarComponent
  ],
    imports: [
        AuthModule.forRoot({
            config: {
                authority: environment.auth.authority,
                redirectUrl: environment.auth.redirectUrl,
                postLogoutRedirectUri: environment.auth.postLogoutRedirectUri,
                clientId: environment.auth.clientId,
                scope: environment.auth.scope,
                // Authorization code flow. This library always applies PKCE to it, which is what
                // a public client with no secret requires — there is no flag to set.
                responseType: 'code',
                silentRenew: true,
                useRefreshToken: true,
                // Renew well before a 4-hour token expires. At 60s a tab that was asleep or
                // backgrounded across the boundary woke up holding a dead token and every request
                // 401'd; 5 minutes gives the refresh room to happen first.
                renewTimeBeforeTokenExpiresInSeconds: 300,
                logLevel: environment.production ? LogLevel.Error : LogLevel.Warn,
            },
        }),
        BrowserModule,
        BrowserAnimationsModule,
        MatSlideToggleModule,
        WatchdogMaterialModule,
        RouterModule.forRoot(AppRoutes),
        SharedModule,
        HttpClientModule,
        NgOptimizedImage,
    ],
  providers: [AUTH_INTERCEPTOR_PROVIDER],
  bootstrap: [AppComponent]
})
export class AppModule { }
